import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import Services from "@/pages/Services";
import Brands from "@/pages/Brands";
import Contact from "@/pages/Contact";
import ScrollToTop from "@/components/ScrollToTop";
import { QuoteModalProvider } from "@/context/QuoteModalContext";
import QuoteModal from "@/components/QuoteModal";

function App() {
  return (
    <div className="App bg-white text-slate-900 min-h-screen">
      <BrowserRouter>
        <QuoteModalProvider>
          <ScrollToTop />
          <Navbar />
          <main data-testid="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/services" element={<Services />} />
              <Route path="/brands" element={<Brands />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
          <QuoteModal />
          <Toaster
            theme="light"
            position="top-right"
            toastOptions={{
              style: {
                background: "#ffffff",
                color: "#0f172a",
                border: "1px solid #e2e8f0",
              },
            }}
          />
        </QuoteModalProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
